
<v-form ref="form" v-if="item">
    <v-container class="inb-info">
        <v-container >
            <f-title :title="$t('inb.detail.head.title')" />
            <c-inb-context
                :item     = "item"
                :readonly = "readonly"
                @morph    = "onMorph"
                @changed  = "onContext"
                ref       = "siteselect"
            />
        </v-container>

        <v-container>
            <f-title title="Störung" class="mt-0">
                <template v-slot:right>
                    <div class="unit-down">
                        <inc-site-down-switch
                            v-model   = "item.sitedown"
                            :readonly = "readonly"
                        />
                    </div>
                </template>
            </f-title>

            <v-row class="no-frame">
                <v-col class="no-frame">
                    <v-select
                        v-model    = "item.incidentType.id"
                        :items     = "incidentTypes"
                        :readonly  = "readonly"
                        :disabled  = "readonly"
                        item-text  = "name"
                        item-value = "id"
                        label      = "Ereignisart"
                    />
                </v-col>
            </v-row>

            <v-row class="no-frame">
            </v-row>

            <v-row class="no-frame">
                <v-text-field
                    v-model        = "item.incidentDetails"
                    label          = "Details zur Störung"
                    :readonly      = "readonly"
                    :disabled      = "readonly"
                    class          = "mt-1"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />
            </v-row>

            <v-row class="no-frame">
                <v-text-field
                    v-model        = "item.kindOfIncident"
                    label          = "Art der Störung"
                    :readonly      = "readonly"
                    :disabled      = "readonly"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />
            </v-row>

            <v-row class="no-frame">
                <v-col class="no-frame mr-2">
                    <v-text-field
                        v-model        = "item.floor"
                        label          = "Aufzug Etage?"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />
                </v-col>
                <v-col class="no-frame ml-2">
                    <v-text-field
                        v-model        = "item.door"
                        label          = "Türen offen?"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />
                </v-col>
            </v-row>
            <f-title :title="`Kommunikation`" />
            <v-row class="no-frame">
                <v-col class ="no-frame mr-2">
                    <f-date-picker
                        label     = "inb.detail.issue.incidentTime"
                        :time     = "true"
                        :readonly = "readonly"
                        v-model   = "item.incidentTime"
                    />
                </v-col>
                <v-col class ="no-frame ml-2">
                    <f-date-picker
                        label     = "inb.detail.issue.transferTime"
                        :time     = "true"
                        :readonly = "readonly"
                        v-model   = "item.transferTime"
                    />
                </v-col>
            </v-row>

            <v-row class="no-frame">
                <v-text-field
                    v-model        = "item.inforeceiver"
                    label          = "Wer wurde informiert?"
                    :readonly      = "readonly"
                    :disabled      = "readonly"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />
            </v-row>

            <v-row class="no-frame">
                <v-text-field
                    v-model        = "item.phonereceiver"
                    label          = "Telefonisch informiert?"
                    :readonly      = "readonly"
                    :disabled      = "readonly"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />
            </v-row>

            <v-row class="no-frame">
                <v-col class ="no-frame mr-2">
                    <v-text-field
                        v-model        = "item.caller"
                        label          = "Anrufer"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />
                </v-col>
                <v-col class ="no-frame ml-2">
                    <v-text-field
                        v-model        = "item.typeOfCaller"
                        label          = "Anrufer Typ"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />
                </v-col>
            </v-row>

            <v-row class="no-frame">
                <v-col class ="no-frame mr-2">
                    <v-text-field
                        v-model        = "item.contactOnSite"
                        label          = "Melder vor Ort?"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />
                </v-col>
                <v-col class ="no-frame ml-2">
                    <v-text-field
                        v-model        = "item.phone"
                        label          = "Rückrufnummer"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />
                </v-col>
            </v-row>

            <f-title
                :title = "`Informationen zur Entstörung`"
                :space = "titleSpace"
            />

            <v-row class="no-frame">
                <v-col class ="no-frame mr-2">
                    <v-text-field
                        v-model        = "item.elimination"
                        label          = "Entstörung gewünscht am"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />
                </v-col>
                <v-col class ="no-frame ml-2">
                    <v-text-field
                        v-model        = "item.orderNotPossible"
                        label          = "Beauftragung nicht möglich?"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</v-form>
